import { useState, useEffect, useCallback } from 'react';
import { fetchProviderDetail } from '../paymentApiService';

export default function useProviderDetail(code) {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!code) return;
    setLoading(true);
    setError(null);
    try {
      const response = await fetchProviderDetail(code);
      setDetail(response.data);
    } catch (err) {
      setError(
        err.response?.data?.error?.message || 'Failed to load provider details'
      );
    } finally {
      setLoading(false);
    }
  }, [code]);

  useEffect(() => {
    load();
  }, [load]);

  return { detail, loading, error, reload: load };
}
